<template>
  <div class="servise-box" >
    <div class="bgPic" id="topBox">
      <div class="picText">
        <p class="title">泽润软件</p>
        <br />
        <span>专业软件开发，全方位服务，可持续发展</span><br />
        <b>响应式网站、小程序、APP应用软件、互联网推广</b>
      </div>
    </div>
    <!-- 解决方案 -->
    <div class="plan-box case">
      <p class="title">解决方案</p>
      <p class="plan">企业个性化量身定制，以实际场景解决核心诉求</p>
      <div class="itcase">
        <el-row>
          <el-col
            :span="5"
            v-for="(item, index) in iconsArr"
            :key="index"
            :offset="index > 0 ? 1 : 0"
          >
            <el-card :body-style="{ padding: '30px 10px', height: '280px' }">
              <el-avatar :size="80" :src="item.imgs"></el-avatar>
              <div>
                <h2>{{ item.title }}</h2>
                <span>{{ item.info1 }}</span
                ><br />
                <span>{{ item.info2 }}</span><br>
                <span>{{ item.info3 }}</span><br>

              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 9大核心 -->
    <div class="core">
      <p class="title">9大核心功能，打造数字化闭环</p>
      <div class="core-box">
        <div class="core-item">
          <el-row style="display: flex; justify-content: center">
            <el-col
              :span="7"
              v-for="(item, index) in coresArr1"
              :key="index"
              style="margin: 5px"
            >
              <el-card :body-style="{ padding: '30px 10px', height: '240px' }">
                <el-avatar :size="80" :src="item.imgs"></el-avatar>
                <div style="padding:0px 10px" class="tex">
                 <h2>{{ item.title }}</h2>
                <span>{{ item.info}}</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="core-item">
          <el-row style="display: flex; justify-content: center">
            <el-col
              :span="7"
              v-for="(item, index) in coresArr2"
              :key="index"
              style="margin: 5px"
            >
              <el-card :body-style="{ padding: '30px 10px', height: '240px' }">
                <el-avatar :size="80" :src="item.imgs"></el-avatar>
                <div style="padding:0px 10px" class="tex">
                 <h2>{{ item.title }}</h2>
                <span>{{ item.info}}</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
        <div class="core-item">
          <el-row style="display: flex; justify-content: center">
            <el-col
              :span="7"
              v-for="(item, index) in coresArr3"
              :key="index"
              style="margin: 5px"
            >
              <el-card :body-style="{ padding: '30px 10px', height: '240px' }">
                <el-avatar :size="80" :src="item.imgs"></el-avatar>
                <div style="padding:0px 10px" class="tex">
                 <h2>{{ item.title }}</h2>
                <span>{{ item.info}}</span>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="advantage">
      <div class="plan-box">
        <p class="title red">我们的优势</p>
        <p class="plan red">海量研发资源，科学项目管理，让你的项目无忧交付</p>
        <div class="item-box">
          <el-row>
          <el-col
            :span="7"
            v-for="(item, index) in advArr"
            :key="index"
            :offset="index > 0 ? 1 : 0"
          >
            <el-card :body-style="{ padding: '30px 10px'}">
              <el-avatar :size="80" :src="item.imgs"></el-avatar>
              <div>
                <h2>{{ item.title }}</h2>
                <span>{{ item.info1 }}</span
                ><br />
                <span>{{ item.info2 }}</span>
              </div>
            </el-card>
          </el-col>
        </el-row>
        </div>
      </div>
    </div>
    <!-- 支持 -->
    <div class="sup-box">
      <span class="title">泽润软件支持</span><br /><br>
      <span>业务涵盖专业软件开发、应用开发与维护、APP定制开发等，可根据客户提供
</span><br>
<span>安全、可靠、高质量、易扩展的解决方案，满足客户不同的发展需求。</span><br><br>
      <div class="item-box">
        <div class="item" v-for="(item, index) in supArr" :key="index">
          <img :src="item.imgs" alt="" style="height: 80px" /><br /><br>
          <span class="title">{{ item.title }}</span
          ><br />
          <p>{{ item.info }}</p>
        </div>
      </div>
    </div>
    <!-- <div class="footer"></div> -->
    <BottomFooter />
</div>
</template>

<script>
import BottomFooter from './bottom.vue'
export default {
  name: "Service",
  components: {
    BottomFooter
  },
  data() {
    return {
      bannerHeight: 500,
      iconsArr: [
        {
          imgs: require("../assets/last/icons/强大的全渠道信息化平台.png"),
          title: "信息化平台",
          info1: ` 全渠道信息化平台,`,
          info2: `综合多种业务场景`,
        },
        {
          imgs: require("../assets/last/icons/智能供应协同管理.png"),
          title: "供应协同",
          info1: "高效低本",
          info2: '采购协同',
          info3:'供应商协同'
        },
        {
          imgs: require("../assets/last/icons/高人效智能客服管理.png"),
          title: "智能客服",
          info1: "语义精准识别，为用户提供 ",
          info2: "专业、人性化、高效率的服务",
        },
         {
          imgs: require("../assets/last/icons/智能供应协同管理.png"),
          title: "顾客关系",
          info1: "智能会员运营管理",
           info2: "用户画像、标签体系",
          info3: "精准营销",
          
        }
      ],
      coresArr1: [
        {
          imgs: require("../assets/last/icons/报表集成图标.png"),
          title: "报表集成",
          info: "SAP ERP、主数据、库存、销售、成本、发票、总账管理、价格体系、获利分析",
        },
        {
          imgs: require("../assets/last/icons/营销管理图标.png"),
          title: "营销管理",
          info: "促销管理、客服中心、售后支持 线下直营、加盟商、电商、自有平台会员营销",
        },
        {
          imgs: require("../assets/last/icons/产品管理图标.png"),
          title: "产品管理",
          info: "商品管理、价格中心、上下架管理",
        },
      ],
      coresArr2: [
        {
          imgs: require("../assets/last/icons/会员管理图标.png"),
          title: "会员管理",
          info: "交易行为、积分管理、会员特性信息",
        },
        {
          imgs: require("../assets/last/icons/订单管理图标.png"),
          title: "订单管理",
          info: "订单寻源、订单处理、库存同步、维权处理、支持拆包发货",
        },
        {
          imgs: require("../assets/last/icons/数据管理图标.png"),
          title: "数据管理",
          info: "热销商品推荐，转化路径分析全掌握,数据实时分析",
        },
      ],
      coresArr3: [
        {
          imgs: require("../assets/last/icons/物流管理图标.png"),
          title: "物流管理",
          info: "支持多种快递，自动分拣系统,物流信息，商品盘点、复核",
        },
        {
          imgs: require("../assets/last/icons/渠道支持图标.png"),
          title: "渠道支持",
          info: "支持小程序和H5、移动端、PC端等多个渠道",
        },
        {
          imgs: require("../assets/last/icons/报表集成图标.png"),
          title: "流程集成",
          info: "全渠道、共享、可视、联动前台、中台、后台",
        },
      ],
      advArr: [
        {
          imgs: require("../assets/last/icons/报表集成图标.png"),
          title: "一站式全方位服务",
          info1: " 咨询、设计、开发、",
          info2: " 质保、运维能力全覆盖",

        },
        {
          imgs: require("../assets/last/icons/流程集成图标.png"),
          title: "服务交付能力稳定",
          info1: "企业级定制开发服务",
          info2: "智能化实施风险预警",

        },
        {
          imgs: require("../assets/last/icons/数据管理图标.png"),
          title: "产品成熟度高",
          info1: "产品已得到市场应用",
          info2: "、复杂场景充分验证",

        },
      ],
      supArr: [
        {
          imgs: require("../assets/last/icons/服务支持.png"),
          title: "服务支持",
          info: "一站式全方位服务，咨询、设计、开发、质保、运维能力全覆盖",
        },
        {
          imgs: require("../assets/last/icons/定制服务.png"),
          title: "定制服务",
          info: "可根据客户需求量身定制符合企业自身产品特点的开发需求",
        },
        {
          imgs: require("../assets/last/icons/数据服务.png"),
          title: "数据服务",
          info: "产品与服务可持续性、可扩展性，确保软件系统能够支援后期发展售后无忧",
        },
      ],
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="less" scoped>
.servise-box {
  .bgPic {
    background: url("../assets/last/bg/关于我们背景.png") no-repeat;
    background-size: cover;
    height: 75vh;
    min-height: 800px !important;
  }
  .picText {
    color: rgb(242, 243, 247);
    text-align: center;
    letter-spacing: 3px;
    line-height: 50px;
    font-family: SourceHanSansCN-Regular-;
    padding-top: 250px;
    .title {
      display: inline-block;
      font-size: 60px;
      font-weight: normal;
      letter-spacing: 7px;
    }

    span {
      font-size: 40px;
    }
    b {
      font-size: 22px;
      font-weight: normal;
    }
    :hover{
      color: rgba(110, 87, 229);
    }
  }
  .case {
    padding-top: 100px;
  }

  .plan-box {
    padding-top: 100px;
    padding-bottom: 100px;
    text-align: center;
    line-height: 30px;
    // background-color: #fff;
    
    .title {
      font-size: 250px;
      font-family: Source Han Sans CN-Bold, Source Han Sans CN;
      font-weight: normal;
      font-size: 40px;
      color: #2f333b;
      line-height: 53px;
    }
    span {
      font-size: 18px;
      letter-spacing: 1px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #999;
    }
    .fontsz {
      display: inline-block;
      text-align: left;
      font-size: 18px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #999;
      line-height: 30px;
    }
    .plan {
      font-size: 30px;
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
      font-weight: normal;
      color: #999;
      line-height: 40px;
    }
    
     .itcase {
      width: 1300px;
      margin: auto;
      margin-top: 50px;
      h2 {
        font-weight: normal;
      }
      p {
        width: 180px;
        height: 52px;
        font-size: 18px;
        font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
        font-weight: normal;
        color: #7c7c8a;
        line-height: 30px;
      }
      :hover{
      color: rgb(140, 189, 250);
    }
    }
    .item-box {
      width: 1000px;
      margin: auto;
      margin-top: 50px;
      h2 {
        font-weight: normal;
      }
      p {
        width: 180px;
        height: 52px;
        font-size: 18px;
        font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
        font-weight: normal;
        color: #7c7c8a;
        line-height: 30px;
      }
      :hover{
      color: rgb(140, 189, 250);
    }
    }
    .thrid {
      .fontsz {
        text-align: left;
        font-size: 20px;
        font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
        font-weight: normal;
        color: #999;
        line-height: 30px;
      }
    }
  }
  // 核心
  .core {
    padding: 100px 0;
    margin: auto;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    letter-spacing: 1px;
  background-color: rgb(248, 248, 248);

    .title {
      font-size: 35px;
    }
  }
  .core-box {
    width: 56%;
    .tex {
      h2{
        font-weight: normal;
      }
      span {
        display: inline-block;
      //  text-align: left;
        font-size: 18px;
        font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
        font-weight: normal;
        color: #999;
        line-height: 25px;
      }
      p {
        color: rgb(181, 181, 189);
        font-size: 14px;
        
      }
:hover{
      color: rgb(66, 111, 216);
    }
    }
    
  
  }
  //
  .advantage {
    margin-bottom: 100px;
  //  background-color: red;
 background: url("../assets/last/bg/数字化营销服务商背景.png") no-repeat;
    background-size: cover;
    height: 870px;
    .red{
      color: #fff;
    }
  }
  // 支持
  .sup-box {
    margin: 70px auto;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    p{
      font-family: SourceHanSansCN-Regular-, SourceHanSansCN-Regular;
       font-weight: normal;
       color: #999;
    }
    span{
      font-size: 22px;
    }
    .title {
      font-size: 40px;
    }

    .item-box {
      margin: auto;
      display: flex;
      justify-content: center;
    }
    .item {
      width: 250px;
      padding: 50px 20px;
      margin: 15px;
      // background-color: aquamarine;
      span {
        font-size: 22px;
      }
      p{
        line-height: 30px;
        font-size: 20px;
      }
      :hover{
      color: rgb(66, 111, 216);
    }
      line-height: 25px;
    }
  }
  // 底部
}

// .footer {
//   background: url("../assets/last/bg/底部.png") no-repeat;
//   background-size: contain;
//   height: 480px;
// }
.idea {
  padding-left: 12px;
}
</style>